import { render, staticRenderFns } from "./ProductInfoSellPrice.vue?vue&type=template&id=481478e5"
import script from "./ProductInfoSellPrice.vue?vue&type=script&lang=ts"
export * from "./ProductInfoSellPrice.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('481478e5')) {
      api.createRecord('481478e5', component.options)
    } else {
      api.reload('481478e5', component.options)
    }
    module.hot.accept("./ProductInfoSellPrice.vue?vue&type=template&id=481478e5", function () {
      api.rerender('481478e5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/ProductInfoSellPrice.vue"
export default component.exports